export class ListingInputModel {
  search: string;
  searchColumns: string[];
  status: string[];
  limit: number = 50;
  orderBy: string; // 'ASC' || 'DESC'
  order: string;
  offset: number = 0;
  joins : joinDataType[];
  filters: {};
  filterLogical: string; // 'AND' || 'OR'
  filterDate: {}
  calcTotalRecords: boolean = true;
  showCreatedBy: boolean = false;
  showUpdatedBy: boolean = false;
  showModifiedBy: boolean = false;
  childs: childDataType[];
  filterConditions: filterConditionDataType[];
  calcTotalRecordsOnly?: boolean = false;
}

export class joinDataType {
  tableName: string;
  joinColumn: string;
  columns: string[];
  joinType?: string;
  filterLogical?: string; // 'AND' || 'OR'
  filterConditions?: filterConditionDataType[];
  alias?: string;
}

export class childDataType {
  tableName: string;
  joinColumn: string;
  filters?: {};
  filterLogical: string;
  filterConditions: filterConditionDataType[];
  joins?: joinDataType[];
  joinType?: string;
  joinColumnWith?: string;
}

export class filterConditionDataType {
  filterColumn: string;
  filterValues: string[];
  filterOperator: string;
}

/*
example data
============
{
"search": "pet-pet",
"searchColumns": ["code", "name"],
"status": [
  "ACTIVE"
],
"orderBy": "date_updated",
"order": "asc",
"limit": "50",
"calcTotalRecords": true,
"showCreatedBy": false,
"showUpdatedBy": true,
"filterLogical": "AND",
"filters": {},
"filterConditions": [
      {
          "filterColumn": "param_code",
          "filterValues" : ["ITEM_STATUS", "ITEM_ATTACHMENT"],
          "filterOperator" : "IN"
      },
      {
          "filterColumn": "param_type",
          "filterValues" : ["FILE"],
          "filterOperator" : "="
      }
  ],
"joins": [
  {
    "tableName": "bl_fi_mst_ecomsync_item_hdr",
    "joinColumn": "bl_fi_mst_ecomsync_item_hdr.fi_item_hdr_guid=hdr.guid",
    "columns": [
      "mkt_guid", "fi_item_hdr_guid"
    ],
    "joinType": "left join"
  },
  {
    "tableName": "bl_fi_mst_branch",
    "joinColumn": "bl_fi_mst_branch.guid=bl_fi_mst_ecomsync_item_hdr.mkt_guid",
    "columns": [
      "code"
    ],
    "joinType": "left join"
  }
],
"filterDate": {
      "dateFrom" : "2021-01-01T16:00:00.000Z",
      "dateTo": "2023-03-31T15:59:59.000Z",
      "column": "date_txn"
},
"childs" : [
    {
      "tableName": "bl_fi_mst_item_ext",
      "joinColumn": "item_hdr_guid",
      "filterLogical": "OR",
      "filterConditions": [
          {
              "filterColumn": "param_code",
              "filterValues" : ["ITEM_STATUS", "ITEM_ATTACHMENT"],
              "filterOperator" : "IN"
          },
          {
              "filterColumn": "param_type",
              "filterValues" : ["FILE"],
              "filterOperator" : "="
          }
      ]
    }
]
}
*/
